export const KNOWN_ADDRESSES = [
  { name: 'Agent', domain: 'agent.aragonpm.eth', type: 'app' },
  { name: 'Finance', domain: 'finance.aragonpm.eth', type: 'app' },
  { name: 'Survey', domain: 'survey.aragonpm.eth', type: 'app' },
  { name: 'Token Manager', domain: 'token-manager.aragonpm.eth', type: 'app' },
  { name: 'Vault', domain: 'vault.aragonpm.eth', type: 'app' },
  { name: 'Voting', domain: 'voting.aragonpm.eth', type: 'app' },

  {
    domain: 'dandelion-voting.aragonpm.eth',
    name: 'Dandelion Voting',
    type: 'app',
  },
  { domain: 'time-lock.aragonpm.eth', name: 'Time Lock', type: 'app' },
  {
    domain: 'token-balance-oracle.aragonpm.eth',
    name: 'Token Balance Oracle',
    type: 'app',
  },
  { domain: 'token-request.aragonpm.eth', name: 'Token Request', type: 'app' },

  { domain: 'redemptions.aragonpm.eth', name: 'Redemptions', type: 'app' },
  { domain: 'address-book.aragonpm.eth', name: 'Address Book', type: 'app' },
  { domain: 'allocations.aragonpm.eth', name: 'Allocations', type: 'app' },
  { domain: 'discussions.aragonpm.eth', name: 'Discussions', type: 'app' },
  { domain: 'dot-voting.aragonpm.eth', name: 'Dot Voting', type: 'app' },
  { domain: 'projects.aragonpm.eth', name: 'Projects', type: 'app' },
  { domain: 'rewards.aragonpm.eth', name: 'Rewards', type: 'app' },
  { domain: 'standard-bounties.aragonpm.eth', name: 'Bounties', type: 'app' },
  {
    domain: 'minime-factory.aragonpm.eth',
    name: 'Minime Token Factory',
    type: 'app',
  },

  {
    name: 'Company',
    domain: 'company-template.aragonpm.eth',
    type: 'template',
  },
  {
    name: 'Membership',
    domain: 'membership-template.aragonpm.eth',
    type: 'template',
  },
  {
    name: 'Reputation',
    domain: 'reputation-template.aragonpm.eth',
    type: 'template',
  },
  {
    name: 'Dandelion',
    domain: 'dandelion-org-template.aragonpm.eth',
    type: 'template',
  },
  {
    name: 'Open Enterprise',
    domain: 'open-enterprise-template.aragonpm.eth',
    type: 'template',
  },
  {
    name: 'Fundraising',
    domain: 'aragon-fundraising.aragonpm.eth',
    type: 'template',
  },
]
